import { __awaiter } from "tslib";
import { buildModuleProps } from '../../rules-engine/moduleProps';
import healthCheckModule from './healthCheckModule';
export const getHealthCheckModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const render = () => {
        // call JS function that's going to check health of the PF
        healthCheckModule(buildModuleProps(moduleConfig, {
            moduleType: moduleConfig.type,
        }));
    };
    return {
        render,
    };
});
